import { render, staticRenderFns } from "./HeroComponent.vue?vue&type=template&id=2d5d29db&scoped=true"
import script from "./HeroComponent.vue?vue&type=script&lang=js"
export * from "./HeroComponent.vue?vue&type=script&lang=js"
import style0 from "./HeroComponent.vue?vue&type=style&index=0&id=2d5d29db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d29db",
  null
  
)

export default component.exports